var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", [
    _vm.bottledByChar > 0
      ? _c(
          "label",
          {
            staticClass: "personalisation-overlay-details--label",
            attrs: { for: "bottledBy-personalisation-input" },
          },
          [_vm._v("bottled by")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-input" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.bottledByInput,
            expression: "bottledByInput",
          },
        ],
        ref: "bottledByInput",
        staticClass: "sensitive",
        attrs: {
          autofocus: "",
          disabled: _vm.adding,
          id: "bottledBy-personalisation-input",
          placeholder: "bottled by",
          maxlength: _vm.bottledByCharMax,
          type: "text",
        },
        domProps: { value: _vm.bottledByInput },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.bottledByInput = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          class:
            _vm.bottledByChar > _vm.bottledByCharMax ? "count-over" : "count",
        },
        [_vm._v(_vm._s(_vm.bottledByChar) + "/" + _vm._s(_vm.bottledByCharMax))]
      ),
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _c(
          "button",
          {
            class:
              _vm.adding || _vm.bottledByChar === 0
                ? "preview-button--disabled"
                : "preview-button",
            staticStyle: { width: "100%" },
            on: { click: _vm.addToCart },
          },
          [_vm._v("Add to cart")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }